
/* 公共方法 */

// 设置cookie
let setCookie = (cname, cvalue) => {
  document.cookie = cname + '=' + encodeURIComponent(cvalue) + ';path=/'
}

// 获取cookie
let getCookie = (cname) => {
  let name = cname + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim()
    if (c.indexOf(name) === 0) {
      return decodeURIComponent(c.substring(name.length, c.length))
    }
  }
  return ''
}

// 获取地址栏中的参数
let getUrlParam = (paramName) => {
  let urlStr = window.location.href
  let urlArray = urlStr.split('?')
  if (urlArray.length === 1) {
    return ''
  }
  let paramsArray = urlArray[1].split('&')
  for (let i = 0; i < paramsArray.length; i++) {
    let oneParam = paramsArray[i].split('=')
    if (oneParam[0] === paramName) {
      return oneParam[1]
    }
  }
  return ''
}

export {
  setCookie,
  getCookie,
  getUrlParam
}



// WEBPACK FOOTER //
// ./src/assets/public.js